import { CSSProperties } from "react";
import {
  FileIcon,
  MenuIcon,
  MoveToIcon,
  RightArrowIcon,
  TicketIcon,
} from "pages/support-tickets/icons";
import { Popover } from "antd";
import { priorityColorObj, ticketStatusConversion } from "./constants";
import { priorityArr } from "../tickets-search-filter/constants";
import styles from "./styles.module.scss";
import { ReactComponent as AttachmentIcon } from "icons/attachmentIcon.svg";

export function Ticket({
  ticketData,
  handleUpdateStatus,
  handleOpenModal,
  setTicketData,
}) {
  function handleTicketClick(e) {
    e.stopPropagation();

    const children = Array.from(e.target?.children);

    const btnClass =
      (children?.length && Array.from(children[0]?.classList)?.[0]) || null;

    const classListCheck =
      (children?.length &&
        Array.from(children[0]?.classList)?.includes(
          "ant-popover-inner-content"
        )) ||
      (btnClass && btnClass?.includes("popoverBtn"));

    const tagsArr = ["BUTTON", "svg", "circle", "path", "SPAN"];
    if (tagsArr.includes(e.target?.tagName) || classListCheck) return;

    setTicketData(ticketData);
    handleOpenModal();
  }

  return (
    <div className={styles.ticket} onClick={handleTicketClick}>
      <TicketHeader
        ticketData={ticketData}
        handleUpdateStatus={handleUpdateStatus}
        // ticketId={ticketData?.ticket_id}
        // priority={ticketData?.priority}
      />

      <TicketBody topic={ticketData?.topic} />

      <TicketFooter ticketData={ticketData} />
    </div>
  );
}

function TicketHeader({ ticketData, handleUpdateStatus }) {
  const { title, priority, ticket_id: ticketId, issueType } = ticketData;

  function PriorityPopover() {
    return (
      <div className={styles.popover}>
        <Popover placement="right" content={<Preferences />} trigger="click">
          <button className={styles.popoverBtn}>
            <MoveToIcon /> Move to{" "}
            <RightArrowIcon className={styles.rightArrow} />
          </button>
        </Popover>
      </div>
    );
  }

  function Preferences() {
    return (
      <div className={styles.preferences}>
        {priorityArr.map((state) => {
          return (
            <button
              type="button"
              style={{ "--color": state.color }}
              className={styles.priority}
              onClick={() => {
                handleUpdateStatus({
                  ticketId: ticketId,
                  value: ticketStatusConversion[state.label],
                });
              }}
            >
              <span></span>
              {state.label}
            </button>
          );
        })}
      </div>
    );
  }

  function Tag({ label, color }) {
    return (
      <div className={styles.priority} style={{ backgroundColor: color }}>
        {label}
      </div>
    );
  }

  return (
    <div className={styles.ticketHeader}>
      <Tag color={priorityColorObj[priority]} label={issueType} />
      <Tag color="#22C55E" label={ticketId} />
      <Tag color={priorityColorObj[priority]} label={priority} />
    </div>
  );
}

function TicketBody({ topic }) {
  return (
    <div className={styles.ticketBody}>
      <p>{topic}</p>
    </div>
  );
}

function TicketFooter({ ticketData }) {
  const { priority, ticket_id, username, sportsName } = ticketData || {};
  const sport = sportsName?.slice(0, 1).toUpperCase() + sportsName?.slice(1);
  return (
    <div className={styles.ticketFooter}>
      <div className={styles.ticketInfo}>
        <div className={styles.name}>
          <img
            src={require("../../../../icons/avatar.png")}
            alt="user-avatar"
          />
          {/* {username} */}
        </div>
        <div className={styles.date}>Dec 3- 8</div>
      </div>

      <div className={styles.files}>
        <AttachmentIcon height={15} width={15} /> 3
      </div>
    </div>
  );
}
